import React from 'react';
import './GeneratingLoader.css';

function GeneratingLoader({defaultFontSize="1.5rem"}) {
  return (
    <div className="generating-card">
      <div className="generating-loader" style={{fontSize:defaultFontSize}}>
        <div className="generating-label">Sales Play is </div>
        <div className="generating-words">
          <span className="generating-word">Thinking</span>
          <span className="generating-word">Analyzing</span>
          <span className="generating-word">Synthesizing</span>
          <span className="generating-word">Generating</span>

        </div>
      </div>
    </div>
  );
}

export default GeneratingLoader;
